import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { WorkflowService } from '../../service/workflow/workflow.service';
import { WorkflowConnection } from 'src/app/models/workflow/workflow-connection.model';
import { WorkflowItem } from 'src/app/models/workflow/workflow-item.model';
import { WorkflowVisualization } from 'src/app/models/workflow/workflow-vis.model';
import { Workflow } from 'src/app/models/workflow/workflow.model';
import { WorkflowItemWrapper } from 'src/app/models/workflow/workflow-item-wrapper.model';
import { WorkflowConnectionWrapper } from 'src/app/models/workflow/workflow-connection-wrapper.model';
import { WorkflowConstants } from 'src/app/models/workflow/workflow-constants';
import { ActivatedRoute } from '@angular/router';
import { IHash } from 'src/app/models/hash.model';
import { WorkflowGraphConnection } from 'src/app/models/workflow/workflow-graph-connection.model';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'workflow-builder',
  templateUrl: './workflow-builder.component.html',
  styleUrls: ['./workflow-builder.component.less']
})
export class WorkflowBuilderComponent extends BaseComponent implements OnInit {

  @ViewChild('graphContainer', { static: true }) graphContainer: ElementRef;

  private graph: mxGraph;
  private workflowItems: WorkflowItem[] = [];    
  private startWorkflowItem: WorkflowItem;  
  private workflow: Workflow = new Workflow();
  private idParam: string;
  private vertexDictionary: IHash = {};   
  private workflowGraphConnections: WorkflowGraphConnection[] = [];

  private defaultNodeStyle = [];    
  private nodeStyle = [];
  private defaultConnectionArrowStyle = [];
  private currentClickedItem: any;


  constructor(private workflowService: WorkflowService, private route: ActivatedRoute, dataService:DataService) {
    super(dataService);
  }

  ngOnInit() {        
    this.workflowService.getAllActions();
    this.idParam = this.route.snapshot.queryParams["id"];

    this.nodeStyle['shape'] = 'rectangle';
    this.nodeStyle['perimeter'] = 'rectanglePerimeter';    
    this.nodeStyle['fillColor'] = 'white';        
    this.nodeStyle['fontColor'] = '#3d464d';                
    this.nodeStyle['fontFamily'] = 'Asap';                    
    this.nodeStyle['verticalAlign'] = 'middle';
    this.nodeStyle['fontSize'] = '15';
    this.nodeStyle['fontStyle'] = 'normal';
    this.nodeStyle['resizable'] = '0'   
    this.defaultNodeStyle = Object.assign({}, this.nodeStyle);

    this.defaultConnectionArrowStyle['shape'] = 'connector';
    this.defaultConnectionArrowStyle['strokeColor'] = '#fa7921';    
    this.defaultConnectionArrowStyle['endArrow'] = 'classic';      
    this.defaultConnectionArrowStyle['strokeWidth'] = '3';  

  }

  ngAfterViewInit() {

    /** DEFAULT ARROW STYLE **/


    let graphContainer = document.getElementById("graphContainer");
    let startXAxis = 700;
    // find container and set axis to middle
    if(graphContainer != null){
      let width = graphContainer.clientWidth;
      if(width > 0){
        startXAxis = width/2;
      }
    }

    // init start action item
    this.startWorkflowItem = new WorkflowItem("Start",2,"",{},{},
    new WorkflowVisualization(startXAxis,WorkflowConstants.WORKFLOW_START_ITEM_YAXIS,
      this.calculateVisualizationUuid(startXAxis,WorkflowConstants.WORKFLOW_START_ITEM_YAXIS)),
    0, "Start2", "");


    this.graph = new mxGraph(this.graphContainer.nativeElement);    
    // Enables new connections in the graph
    this.graph.setConnectable(true);
    this.graph.setMultigraph(false);
    this.graph.setDropEnabled(true);    

    // Needs to set a flag to check for dynamic style changes,
		// that is, changes to styles on cells where the style was
		// not explicitely changed using mxStyleChange
    this.graph.getView().updateStyle = true;          
    
    this.graph.addMouseListener(
      {
          graph: this.graph,          
          defaultNodeStyle: this.defaultNodeStyle,
          previousClickedNodeState: null,          
          currentClickedItem: this.currentClickedItem,
          mouseDown: function(sender, me){},                    
          mouseMove: function(sender, me){},
				  mouseUp: function(sender, me) {
            var nodeState = this.graph.getView().getState(me.getCell());                            
            
            if(nodeState != null) {
              let isVertex = this.graph.getModel().isVertex(nodeState.cell);
              if(isVertex) {

                if(this.previousClickedNodeState != null) {
                  this.previousClickedNodeState.style = Object.assign({} ,this.defaultNodeStyle);
                  this.previousClickedNodeState.shape.apply(this.previousClickedNodeState);
                  this.previousClickedNodeState.shape.redraw(); 
                }

                // remove icon from previous clicked item
                if(this.currentClickedItem != null && typeof this.currentClickedItem != "undefined") {
                  let settingsItemImg = this.currentClickedItem["SettingsImage"];
                  if(typeof settingsItemImg != "undefined"){
                    settingsItemImg.parentNode.removeChild(settingsItemImg);
                  }      
                }

                // set settings icon
                this.currentClickedItem = mxIconSet(nodeState, this.currentClickedItem);
                nodeState.style['fontColor'] = "white";
                
                // when clicked remove overlay with current image
                
                // add new overlay with white image
                //var overlay = new mxCellOverlay(new mxImage("../../../../../Content/css/Images/workflow/icon_save.png", 35, 35), null, "center", "middle", null, null);                                                				        
				        //this.graph.addCellOverlay(nodeState.cell, overlay);
                
                nodeState.style['fillColor'] = '#5bc0eb';                                                      
                nodeState.shape.apply(nodeState);
                nodeState.shape.redraw(); 
                this.previousClickedNodeState = nodeState;                
              }              
            }

          },             
          dragEnter: function(evt, state) { },
          dragLeave: function(evt, state) { }
      });


      // Defines a new class for all icons
		function mxIconSet(state, currClickedItem)
		{			
      // settings icon      
      var itemImg = document.createElement("IMG");
      itemImg.setAttribute("src", "../../../../../Content/css/Images/ikona-nastavitve@3x.png");			
			itemImg.style.position = 'absolute';
			itemImg.style.cursor = 'pointer';
			itemImg.style.width = '20px';
			itemImg.style.height = '20px';
      itemImg.style.left = (state.x + 135) + 'px';      
      itemImg.style.top = (state.y) + 'px';							
			state.view.graph.container.appendChild(itemImg);
             
      if(typeof currClickedItem == "undefined" || currClickedItem == null) {
        currClickedItem = {
          "SettingsImage": itemImg
        }
      } else {
        currClickedItem["SettingsImage"] = itemImg;
      }

      return currClickedItem;

    };		 
        

	  // styling of connection arrows    
    this.graph.getStylesheet().putDefaultEdgeStyle(this.defaultConnectionArrowStyle);
     // set styling of nodes
    this.graph.getStylesheet().putDefaultVertexStyle(this.nodeStyle);        

    // add default node "start"
    this.graph.getModel().beginUpdate();
    try {
      let startVertex = this.graph.insertVertex(this.graph.getDefaultParent(), this.startWorkflowItem.ClientId, this.startWorkflowItem.ActionName, this.startWorkflowItem.VisualizationData.Xaxis, this.startWorkflowItem.VisualizationData.Yaxis, 125, 125);                              
      this.vertexDictionary[this.startWorkflowItem.ClientId] = startVertex;
      // find cell that represents "Start" action item and disable dragging    
      this.graph.setCellStyles('movable','0',[this.graph.getModel().cells[this.startWorkflowItem.ClientId]]);         
    } finally {
      this.graph.getModel().endUpdate();            
    }         

    // subsrice if user adds another node (Workflow action) to graph
    this.workflowService.currentAddedAction.subscribe(workflowAction => {      
      if(typeof workflowAction != "undefined" && workflowAction != null && workflowAction.ActionName != null && typeof workflowAction.ActionName != "undefined" && workflowAction.ActionName.length > 0 && typeof workflowAction.ClientId != "undefined"){
        this.addNodeToGraph(workflowAction);
      }      
    });    



    if(typeof this.idParam != "undefined" && this.idParam != null) {
      this.workflowService.getWorkflow(this.idParam).subscribe(workflow => {

        if(workflow != null){  
          // save current workflow to property
          this.workflow = workflow;        
          // show title of workflow on UI
          this.workflowService.changeWorkflowName(workflow.Title);

          if(workflow.WorkflowItems != null && workflow.WorkflowItems.$values != null) {
            this.graph.getModel().beginUpdate();
            try{
              for(let i = 0; i < workflow.WorkflowItems.$values.length; i++) {
                
                let workflowItem = workflow.WorkflowItems.$values[i];

                let xaxis = workflowItem.VisualizationData.Xaxis;
                let yaxis = workflowItem.VisualizationData.Yaxis;
                let currentClientId = workflowItem.ActionName + workflowItem.Id;

                // source vertex
                // insert node into graph
                let vertexValue = workflowItem.ActionName + workflowItem.Id;
                workflowItem.ClientId = vertexValue;
                let vertex = this.graph.insertVertex(this.graph.getDefaultParent(), vertexValue, workflowItem.ActionName, xaxis, yaxis, 125, 125);                                 
                
                // also insert item picture                	
                var overlay = new mxCellOverlay(new mxImage("../../../../../Content/css/Images/workflow/start@3x.png", 35, 35), null, "center", "middle", null, null);                                                
				        // Sets the overlay for the cell in the graph
				        this.graph.addCellOverlay(vertex, overlay);

                this.vertexDictionary[currentClientId] = vertex;
                this.workflowItems.push(workflowItem);                              

                // connect other workflow items
                // "IncomingConnections" are connections coming into workflow item
                // if list is empty workflowaction has no items coming into - assume that this is 1st item so workflow item coming into this is START
                if(typeof workflowItem.IncomingConnections != undefined && workflowItem.IncomingConnections.$values.length == 0) {                  
                  let sourceId = this.startWorkflowItem.ActionName + this.startWorkflowItem.Id;
                  // currentItem is always target because we're working iwth IncomingConnections
                  this.workflowGraphConnections.push(new WorkflowGraphConnection(sourceId,currentClientId,0,null));

                } else {
                  for(let j = 0; j < workflowItem.IncomingConnections.$values.length; j++) {
                  
                    // for update purposes get version and id of connection
                    let connectionVersion = workflowItem.IncomingConnections.$values[j].Version;
                    let connectionId = workflowItem.IncomingConnections.$values[j].Id;
                    // get source workflow item (node that connection is comming from)
                    let source = workflowItem.IncomingConnections.$values[j].Source;                  
                    let sourceId = null;
  
                    if(source != null){
                      sourceId = source.ActionName + source.Id;
                    }else{
                      // if null then it's connected to start
                      //sourceId = this.startWorkflowItem.ActionName + this.startWorkflowItem.Id;
                    }                  
  
                    if(sourceId != null){
                      // currentItem is always target because we're working iwth IncomingConnections
                      this.workflowGraphConnections.push(new WorkflowGraphConnection(sourceId,currentClientId,connectionId,connectionVersion));
                    }                    
                  }
                }                
              }                                         
              
              // connect other items
              for(let i = 0; i < this.workflowGraphConnections.length; i++) {

                let vertexSource = this.vertexDictionary[this.workflowGraphConnections[i].SourceId];
                let vertexTarget = this.vertexDictionary[this.workflowGraphConnections[i].TargetId];

                this.graph.insertEdge(this.graph.getDefaultParent(), '', '', vertexSource, vertexTarget);
              }

            }finally{
              this.graph.getModel().endUpdate();
            } 
          }          
        }
      });
    }    

  }  

  saveWorkflow() {


    // before saving, clear previous wokrflow item connections
    if(this.workflowItems != null) {
      for(let i = 0; i < this.workflowItems.length; i++){
        this.workflowItems[i].OutgoingConnections = null;
        this.workflowItems[i].IncomingConnections = null;
      }
    }    

    //first map workflow graph to model
    if(this.graph != null && this.graph.getModel() != null && this.graph.getModel().cells != null) {            

      // convert cells (which is object) to list
      let currCells = this.graph.getModel().cells;
      let graphCellList = Object.keys(currCells).map(function(key) {
        return [currCells[key]];
      });
      
      for(let i = 0; i < graphCellList.length; i++){        
        if(typeof graphCellList[i][0].geometry != "undefined"){

          // if workflow item (graph node)
          if(graphCellList[i][0].vertex) {            
            // find added workflow by id and action name
            let index = this.workflowItems.findIndex(x => x.ClientId == graphCellList[i][0].id)            

            if(index >= 0){                            
              // add visualization and order
              let xaxis = this.getXaxis(graphCellList[i][0]);
              let yaxis = this.getYaxis(graphCellList[i][0]);              
              let visualization = new WorkflowVisualization(xaxis,yaxis,this.calculateVisualizationUuid(xaxis,yaxis));
              this.workflowItems[index].VisualizationData = visualization;
              this.workflowItems[index]["$type"] = WorkflowConstants.WORKFLOW_ACTION_ITEM_TYPE;              
            } else {
              // check if current graph node is actualy start item
              if(this.startWorkflowItem.ClientId == graphCellList[i][0].id){
                let xaxis = this.getXaxis(graphCellList[i][0]);
                let yaxis = this.getYaxis(graphCellList[i][0]);     
                let visualization = new WorkflowVisualization(xaxis,yaxis,this.calculateVisualizationUuid(xaxis,yaxis));
                this.startWorkflowItem.VisualizationData = visualization;
                //this.workflowItems.unshift(this.startWorkflowItem);
              }  
            }            

          } else if(graphCellList[i][0].edge) { // if workflow connection

            // add connection only if source and target are not null
            if(graphCellList[i][0].source != null && graphCellList[i][0].target != null){

              // find source position              
              let sourceIndex = this.workflowItems.findIndex(x => x.ClientId == graphCellList[i][0].source["id"]);            
              // find target position
              let targetIndex = this.workflowItems.findIndex(x => x.ClientId == graphCellList[i][0].target["id"]);

              let targetWorkflowItem = null;
              if(targetIndex >= 0){
                targetWorkflowItem = Object.assign({}, this.workflowItems[targetIndex]);
                // set to null so there wont be circular reference when parsing json for save request
                targetWorkflowItem.OutgoingConnections = null;
                targetWorkflowItem.IncomingConnections = null;
                targetWorkflowItem.$type = WorkflowConstants.WORKFLOW_ACTION_ITEM_TYPE;

                
                // check if connection already exists
                if(this.workflowItems[targetIndex].IncomingConnections == null || typeof this.workflowItems[targetIndex].IncomingConnections == "undefined"){
                  this.workflowItems[targetIndex].IncomingConnections = new WorkflowConnectionWrapper(WorkflowConstants.WORKFLOW_CONNECTIONS_TYPE);
                }                
              }


              // if both are found then nodes are connected
              if(sourceIndex >= 0 && targetWorkflowItem != null){                                
                let sourceWorkflowItem = Object.assign({}, this.workflowItems[sourceIndex]);
                
                // set to null so there wont be circular reference when parsing json for save request
                sourceWorkflowItem.OutgoingConnections = null;
                sourceWorkflowItem.IncomingConnections = null;
                sourceWorkflowItem.$type = WorkflowConstants.WORKFLOW_ACTION_ITEM_TYPE;                              
                
                // for update purposes get connection version and id                
                let workflowGraphConnection = this.workflowGraphConnections.find(x => x.SourceId == graphCellList[i][0].source["id"] && x.TargetId == graphCellList[i][0].target["id"]);
                let wfConnectionId = 0;
                let wfVersion = null;
                if(typeof workflowGraphConnection != "undefined"){
                  wfConnectionId = workflowGraphConnection.Id;
                  wfVersion = workflowGraphConnection.Version;
                }

                let wfConnection = new WorkflowConnection(WorkflowConstants.WORKFLOW_CONNECTION_TYPE, sourceWorkflowItem, targetWorkflowItem, wfVersion, wfConnectionId);

                this.workflowItems[targetIndex].IncomingConnections.$values.push(wfConnection);
                //this.workflowItems[sourceIndex].ConnectionsFromSource.push(new WorkflowConnection(sourceWorkflowItem,targetWorkflowItem));
                //this.workflowConnections.push(new WorkflowConnection(sourceWorkflowItem,targetWorkflowItem));

              } else if(sourceIndex == -1 && targetWorkflowItem != null) {

                //we must find connection with start item
                let startActionSourceId = this.startWorkflowItem.ActionName + this.startWorkflowItem.Id;
                let workflowGraphConnection = this.workflowGraphConnections.find(x => x.SourceId == startActionSourceId && x.TargetId  == graphCellList[i][0].target["id"]);
                
                let wfConnectionId = 0;
                let wfVersion = null;
                if(typeof workflowGraphConnection != "undefined"){
                  wfConnectionId = workflowGraphConnection.Id;
                  wfVersion = workflowGraphConnection.Version;
                }

                let wfConnection = new WorkflowConnection(WorkflowConstants.WORKFLOW_CONNECTION_TYPE, null, targetWorkflowItem, wfVersion, wfConnectionId);
                this.workflowItems[targetIndex].IncomingConnections.$values.push(wfConnection);
              }
            }                        
          }          
        }
      }

      // check if new or update
      if(this.workflow.Id == 0 || typeof this.workflow.Id == "undefined"){        
        this.workflow.$type = WorkflowConstants.WORKFLOW_WORKFLOW_TYPE;
        this.workflow.CurrentStep = 1;
        this.workflow.Status = 1;
      }            
      this.workflow.WorkflowItems = new WorkflowItemWrapper(WorkflowConstants.WORKFLOW_ABSTRACT_ITEMS_TYPE, this.workflowItems);      
      this.workflowService.saveWorkflow(this.workflow);

    }    
  }

  addNodeToGraph(workflowAction: WorkflowItem) {     
    this.graph.getModel().beginUpdate();

    try {

      let clientId = "";

      if(workflowAction.ClientId == null || typeof workflowAction.ClientId == "undefined" || workflowAction.ClientId.length == 0){
        clientId = workflowAction.ActionName + workflowAction.Id;
      }else{
        clientId = workflowAction.ClientId;
      }

      this.graph.insertVertex(this.graph.getDefaultParent(), clientId, workflowAction.ActionName, 0, 0, 125, 125);      
    } finally {
      this.graph.getModel().endUpdate();            
    }      

    this.workflowItems.push(workflowAction);
  }


  private calculateVisualizationUuid(xaxis:number, yaxis:number){
    
    // random num between 1 and 100
    let random = Math.floor(Math.random()*(100-1+1)+1);

    return ""+xaxis + yaxis + random;
  }
  
  private getXaxis(cell: any){
    
    if(cell != null && typeof cell != "undefined" && cell.geometry != null && typeof cell.geometry != "undefined"){
      return cell.geometry["x"];
    }
    return 0;
  }

  private getYaxis(cell: mxCell){
    if(cell != null && typeof cell != "undefined" && cell.geometry != null && typeof cell.geometry != "undefined"){
      return cell.geometry["y"];
    }
    return 0;
  }   

}
